/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ERRORS } from './Error.constants';
import { ErrorWithHttpStatusCode } from './ErrorWithHttpStatusCode';

/**
 * Bad request error (400).
 * @export
 * @class BadRequestError
 * @extends {ErrorWithHttpStatusCode}
 */
export class BadRequestError extends ErrorWithHttpStatusCode {
  constructor(
    public details: string,
    message = ERRORS.badRequest.name,
  ) {
    super(ERRORS.badRequest.code, message, details);
  }
}
